import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { Documents } from '@egw/features-documents'

export const DocumentsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.documents.title')} />
      <Documents />
    </Layout>
  )
}
